export const validateNumbers = (e) => {
    const re = /^[0-9]*$/
    if (e.target.value.length > 0) {
        if (!re.test(e.target.value)) {
            e.target.value = e.target.value.substring(0, e.target.value.length - 1)
        }
    }

    return e.target.value
}